import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class WorkflowService {
  index(payload) {
    let filters = {};
    if (payload.options) {
      filters = { ...filters, ...payload.options };
    }

    if (payload.search) {
      filters = { ...filters, search: payload.search };
    }

    return axios.get(API_URL + "approvals/approval-workflows", {
      params: filters,
      headers: authHeader(),
    });
  }
  show(id) {
    return axios.get(API_URL + "approvals/approval-workflows/" + id, { headers: authHeader() });
  }
  store(item) {
    return axios.post(API_URL + "approvals/approval-workflows", item, { headers: authHeader() });
  }
  update(item) {
    return axios.post(API_URL + "approvals/approval-workflows/" + item.id, item, {
      headers: authHeader(),
    });
  }
  delete(item) {
    return axios.delete(API_URL + "approvals/approval-workflows/" + item.id, {
      headers: authHeader(),
    });
  }
  getApprovalGroups() {
    return axios.get(API_URL + "approvals/approval-groups?per_page=-1", { headers: authHeader() });
  }
  updateWorkflowSteps(item) {
    return axios.post(API_URL + "approvals/approval-workflow-order", item, {
      headers: authHeader(),
    });
  }
  getApprovalWorkflows(organizationId) {
    return axios.get(API_URL + "approvals/approval-workflows", {
      params: { 
        organization_id: organizationId,
        per_page: -1
      },
      headers: authHeader(),
    });
  }
}

export default new WorkflowService();
